/**
 * useMembership — ¿el cliente actual es miembro con plan pago o es Free?
 *
 * Freemium (29-sep-2026): Free = cliente sin membresía paga (sin fila activa
 * en `subscriptions`). Ve todo el espacio privado, con candado en lo que es
 * de miembros: comunidad, puntos y logros, referidos, eventos de miembros y
 * los cursos que no están marcados Free.
 *
 * - isMember: admin, guru o plan pago vigente (active / trialing / past_due).
 * - isFreeClient: cliente con sesión, ya cargado, sin nada de lo anterior.
 *   Mientras carga es false: nunca se muestra un candado a un miembro por
 *   un parpadeo de carga.
 */
import { useUser } from '@/lib/auth';
import { useUserRoles } from '@/lib/hooks/useUserRoles';
import { useMySubscription } from '@/lib/api/subscription';

export interface MembershipStatus {
  loading: boolean;
  isMember: boolean;
  isFreeClient: boolean;
  hasPaidPlan: boolean;
}

export function useMembership(): MembershipStatus {
  const user = useUser();
  const { data: roles, isLoading: rolesLoading } = useUserRoles();
  const { data: sub, isLoading: subLoading } = useMySubscription();

  const loading = !!user && (rolesLoading || subLoading || !roles);
  const isStaff = !!roles && (roles.includes('admin') || roles.includes('guru'));
  const hasPaidPlan = !!sub && String(sub.plan_code) !== 'free';
  const isMember = isStaff || hasPaidPlan;

  return {
    loading,
    isMember,
    isFreeClient: !!user && !loading && !isMember,
    hasPaidPlan,
  };
}

/** Destino único para "mejorar mi plan" desde adentro del panel. */
export const UPGRADE_PATH = '/account?tab=suscripcion';
